function conditionalDataLoad({
    isSuperAdmin,
    isAdmin,
    hasMultiBranch,
    hasSingleBranch,
    vendorId,
    branchId
}) {
    if (isSuperAdmin) {
        // Must pick vendor + branch
        return Boolean(vendorId && branchId);
    }

    if (isAdmin) {
        // Only branch selection required
        return Boolean(branchId);
    }

    // Normal User: MULTI-BRANCH → must pick branch
    if (hasMultiBranch) {
        return Boolean(branchId);
    }

    // Normal User: SINGLE BRANCH → auto load
    if (hasSingleBranch) {
        return true;
    }

    // Fallback normal user
    return true;
}

export default conditionalDataLoad;
